export default __webpack_public_path__ + "media/images/titre-ongletright-c9f1552d592bac59694ac739b1b9e884.png";